var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 71.6 71.1",
    style: {
      enableBackground: "new 0 0 71.6 71.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#5C2881;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 35.8,
    cy: 35.5,
    r: 35.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.6,20.4H31.5v-1.5c0-1-0.8-1.9-1.9-1.9c-1,0-1.9,0.8-1.9,1.9v1.6c-1.4,0.2-2.5,1.4-2.5,2.9v27.8 c0,1.6,1.3,2.9,2.9,2.9h15.5c1.6,0,2.9-1.3,2.9-2.9V23.3C46.5,21.7,45.2,20.4,43.6,20.4z M33.1,44.4c0,0.2-0.2,0.3-0.5,0.3h-4.4 c-0.3,0-0.5-0.1-0.5-0.3v-2.6c0-0.2,0.2-0.3,0.5-0.3h4.4c0.3,0,0.5,0.1,0.5,0.3V44.4z M37.4,44.4c0,0.2-0.1,0.3-0.3,0.3h-2.5 c-0.2,0-0.3-0.1-0.3-0.3v-2.6c0-0.2,0.1-0.3,0.3-0.3h2.5c0.2,0,0.3,0.1,0.3,0.3V44.4z M44,44.4c0,0.2-0.2,0.3-0.5,0.3H39 c-0.3,0-0.5-0.1-0.5-0.3v-2.6c0-0.2,0.2-0.3,0.5-0.3h4.5c0.3,0,0.5,0.1,0.5,0.3V44.4z M44,38.6c0,0.9-0.7,1.6-1.6,1.6H29.2 c-0.9,0-1.6-0.7-1.6-1.6V24.6c0-0.9,0.7-1.6,1.6-1.6h13.2c0.9,0,1.6,0.7,1.6,1.6V38.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/Mobile.6f103ec765155fc3b89c18d45237eccb.svg";
export { ForwardRef as ReactComponent };